import { Grid, Typography } from '@material-ui/core'
import React from 'react'

function SubCategoryView({ subcategory }) {
  const data = [
    { label: 'Category', data: subcategory.categoryId && subcategory.categoryId.categoryName },
    { label: 'SubCategory', data: subcategory.name },
    { label: 'Image', data: subcategory.image },
    { label: 'Description', data: subcategory.description },
  ]
  return (
    <Grid container>
      <Grid item lg={12} container spacing={3}>
        {data.map((item, index) => (
          <Grid item lg={4} key={index}>
            <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
              <Typography>{item.label}</Typography>
              {item.label === 'Image' ? (
                <img src={item.data} alt="catgeory" width="50%" />
              ) : (
                <Typography>{item.data}</Typography>
              )}
            </div>
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}

export default SubCategoryView
